export const pieces = state => state.pieces

export const expenseGroups = state => state.expenseGroups

export const solicitude = state => state.solicitude
